import { NgModule } from '@angular/core';
import { DividerComponent } from './divider.component';

/**
 * @deprecated import DividerComponent directly
 */
@NgModule({
  imports: [DividerComponent],
  exports: [DividerComponent]
})
export class DividerModule {}
